var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#00A4EA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.027 28.85c-.715 0-.593-.27-.84-.95l-2.103-6.92 16.185-9.602",
  fill: "#C8DAEA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.028 28.85c.552 0 .796-.253 1.104-.552l2.942-2.861-3.67-2.214",
  fill: "#A9C9DD"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.402 23.224l8.894 6.572c1.015.56 1.748.27 2-.943l3.621-17.06c.37-1.486-.566-2.16-1.537-1.72L9.12 18.271c-1.45.582-1.442 1.391-.264 1.752l5.456 1.703 12.63-7.968c.596-.362 1.143-.168.694.231",
  fill: "url(#dark-rounded_svg__paint0_linear_816_1348)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dark-rounded_svg__paint0_linear_816_1348",
  x1: 23.84,
  y1: 18.737,
  x2: 27.284,
  y2: 26.584,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFF7FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMwMEE0RUEiLz4KPHBhdGggZD0iTTE3LjAyNzIgMjguODUwMUMxNi4zMTIxIDI4Ljg1MDEgMTYuNDMzNyAyOC41ODAxIDE2LjE4NyAyNy44OTkzTDE0LjA4NDUgMjAuOTc5N0wzMC4yNjkzIDExLjM3NzkiIGZpbGw9IiNDOERBRUEiLz4KPHBhdGggZD0iTTE3LjAyODEgMjguODQ5OEMxNy41Nzk4IDI4Ljg0OTggMTcuODIzNSAyOC41OTc1IDE4LjEzMTYgMjguMjk4MUwyMS4wNzQzIDI1LjQzNjdMMTcuNDAzNiAyMy4yMjMyIiBmaWxsPSIjQTlDOUREIi8+CjxwYXRoIGQ9Ik0xNy40MDIyIDIzLjIyNDRMMjYuMjk2NCAyOS43OTU2QzI3LjMxMTUgMzAuMzU1NyAyOC4wNDM4IDMwLjA2NTYgMjguMjk2NyAyOC44NTM0TDMxLjkxNzIgMTEuNzkyNkMzMi4yODc4IDEwLjMwNjYgMzEuMzUwNyA5LjYzMjMxIDMwLjM3OTYgMTAuMDczMkw5LjEyMDQ5IDE4LjI3MDZDNy42NjkzOCAxOC44NTI3IDcuNjc4MDIgMTkuNjYyMyA4Ljg1NjAyIDIwLjAyM0wxNC4zMTE2IDIxLjcyNTlMMjYuOTQxOCAxMy43NTc2QzI3LjUzODEgMTMuMzk2IDI4LjA4NTQgMTMuNTkwMiAyNy42MzYzIDEzLjk4OSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzgxNl8xMzQ4KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzgxNl8xMzQ4IiB4MT0iMjMuODQiIHkxPSIxOC43MzY3IiB4Mj0iMjcuMjg0MyIgeTI9IjI2LjU4NDMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0VGRjdGQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgDarkRounded as ReactComponent };